<button mat-stroked-button type="button" class="btn boton-imagen" (click)="(onClick)">
    <div class="image-container">
        <img src="/assets/apple-logo.png" width="50" />
        <p>Sign in with Apple</p>
    </div>
</button>
